import React                from 'react';
import createReactClass     from 'create-react-class';
import Reflux               from 'reflux';
import Parse                from 'parse';
import Spinner              from '../generic/spinner';
import Api                  from '../../Utils/api';
import Utils                from '../../Utils/Utility';
import MainStore            from '../stores/main-store';
import Actions              from '../../actions';
import AllItems             from './all-items';
import AddItem              from './add-item';

const Items = createReactClass({

    // contextTypes is used to pushed the routes in url
    contextTypes : {
        router : React.PropTypes.object.isRequired
    },

    mixins : [
        Reflux.listenTo(MainStore, 'onChange')
    ],

    getInitialState() {
        return {
            data : {
                LocationDetail    : null,
                BusinessDetail    : null,
                BusinessLocations : [],
                GroupDetails      : [],
                ItemDetails       : [],
                groupHierarchy    : [],
                menuHierarchy     : []
            },
            defaultLocationActive : false,
            defaultLocId            : null,
            showAddItemView         : false,
            showAllItemView         : false,
            defaultItemDetail       :{},
            isLoaded                : true,
            duplicateItem           : false,
            addItemView             : false,
        };
    },

    onChange(event, data) {

        let activeLocationIndex = 0;
        const dataToSet = this.state.data;
        if (dataToSet.BusinessDetail === null) {
            dataToSet.BusinessDetail = data.BusinessDetail;
            // this.populateSessionStorage(data.BusinessDetail);
        }
        if (dataToSet.BusinessLocations.length === 0) {
            dataToSet.BusinessLocations = data.BusinessLocations;
        }

        if (dataToSet.LocationDetail === null || (dataToSet.LocationDetail !== null && dataToSet.LocationDetail.objectId !== data.LocationDetail.objectId)) {
            dataToSet.LocationDetail = data.LocationDetail;
        }

        dataToSet.GroupDetails = data.GroupDetails;
        dataToSet.ItemDetails = data.ItemDetails;
        dataToSet.groupHierarchy = data.groupHierarchy;
        dataToSet.menuHierarchy = data.menuHierarchy;

        // console.log(JSON.stringify(data.GroupDetails)); // Groups only
        // console.log(JSON.stringify(data.ItemDetails)); // Items Only
        // console.log(JSON.stringify(data.groupHierarchy)); // Group with Items in array
        // console.log(JSON.stringify(data.menuHierarchy)); // Menu name only

        activeLocationIndex = this.getActiveLocationIndex(data);

        this.setState({ data : dataToSet, activeLocationIndex ,  isLoaded: true});

    },

    getActiveLocationIndex(data) {

        let index = 0;
        if (data.LocationDetail) {
            data.BusinessLocations.some((location, idx) => {
                if (location.objectId == data.LocationDetail.objectId) {
                    index = idx;
                    return true;
                }
            });
        }

        return index;
    },


    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps != null && nextProps.isActive) {
            return true;
        } else {
            return false;
        }
    },

    componentWillMount() {

        Utils.isUserSessionInvalid().then((response) => {
            // user session in valid
            this.setState({
                activeLocation : this.props.activeLocation,
                isUserSessionInvalid : true
            });

        }, (error) => {
            // user session is invalid
            Utils.checkErrorIsInvalidSessionToken(error, this.context.router);

        });
    },

    componentWillReceiveProps(nextProps) {
        if (nextProps != null) {
            this.setState({
                activeLocation : nextProps.activeLocation
            });
        }
    },

    componentDidMount(){
        // when load the main class get all the data and reload
        this.getAllDataAndReload();

    },

    getAllDataAndReload() {

        // set the defaultLocationActive state true when location send on the url
        // set location id in the defaultLocId state
        if (this.props.activeLocation != null) {
           let activeLocationId = this.props.activeLocation.objectId;
            this.setState({
                defaultLocationActive : true,
                defaultLocId          : activeLocationId,
                showAllItemView : true,
                isLoaded : false
            });
            Actions.getAllData(null, activeLocationId);

        } else {
            Actions.getAllData();
        }
    },

    addNewItemAction(){
        this.setState({
            showAllItemView : false,
            showAddItemView: true,
            duplicateItem: false,
            defaultItemDetail:{},
            addItemView: true
        });
    },

    updateItemAction(itemDetail){
        this.setState({
            showAllItemView : false,
            showAddItemView: true,
            duplicateItem: false,
            defaultItemDetail:itemDetail,
            addItemView: false
        });
    },

    duplicateItemAction(itemDetail){
        this.setState({
            showAllItemView : false,
            showAddItemView: true,
            duplicateItem: true,
            defaultItemDetail:itemDetail,
            addItemView: false
        });
    },

    deleteItemAction(itemDetail){

        let result = confirm("Are you sure you want to delete "+itemDetail.itemName+"?");
        if (result) {


            //Logic to delete the item
            let currentUser = Parse.User.current();
            let userId = currentUser.id;
            let sessionToken = currentUser.getSessionToken();
            let businessDetail = currentUser.get("bizId");
            let bizId = businessDetail.id;

            let params = {
                "objectId"    : itemDetail.objectId,
                "bizId"    : Utils.getPointerFor("BusinessDetail",bizId),
            };

            let self = this;

            self.setState({
                isLoaded : false
            });
            Api.deleteItemDetail(userId, sessionToken, bizId, params)
                .then(
                    (result) => {
                        const response = result.data;

                        // reload all the items
                        self.getAllDataAndReload();

                    },
                    (error) => {
                        Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                        self.setState({isLoaded : false });
                        console.log("Error occured while fetching latest user data!");
                    }
                );
        }

    },

    callBackAfterUpdate(){
        this.setState({
            showAllItemView : true,
            showAddItemView: false,
            duplicateItem: false,
            defaultItemDetail:{},
            addItemView: false

        }, ()=>{
            // when load the main class get all the data and reload
            this.getAllDataAndReload();
        });
    },
    callBackParent(){
        this.setState({
            showAllItemView : true,
            showAddItemView: false,
            duplicateItem: false,
            defaultItemDetail:{},
            addItemView: false
        });
    },

    render(){

        return (
            <div className="order-pg">
                {!this.state.isLoaded ? <Spinner/> : null}
                  {
                      this.state.showAllItemView ? (
                          <div>
                              <AllItems
                                  activeLocation = {this.props.activeLocation}
                                  groupHierarchy={this.state.data.groupHierarchy}
                                  callBackAddItem={this.addNewItemAction}
                                  callBackUpdateItem={this.updateItemAction}
                                  callBackDuplicateItem={this.duplicateItemAction}
                                  callBackDeleteItem={this.deleteItemAction}
                              ></AllItems>
                          </div>
                      ) : null

                  }
                  {
                      this.state.showAddItemView ? (
                          <div>
                              <AddItem
                                  activeLocation = {this.props.activeLocation}
                                  groups = {this.state.data.GroupDetails}
                                  itemDetail = {this.state.defaultItemDetail}
                                  duplicateItem = {this.state.duplicateItem}
                                  callBackAfterUpdate={this.callBackAfterUpdate}
                                  callBackParent={this.callBackParent}
                                  addItemView = {this.state.addItemView}
                              />
                          </div>
                      ) : null

                  }
            </div>
        )
    }
});

export default Items;




// WEBPACK FOOTER //
// src/components/online-menu/items.js